<mat-card class="product-barchart">
  <mat-card-content>
    <h3 class="font-size-13 mb-3">{{textService.currentText.salesByProduct}}</h3>
    <div echarts [options]="echartProductBarOptions" style="height: 330px"></div>
  </mat-card-content>
</mat-card>